"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _bcmKunrenActions = require("../bcmKunrenActions");
var _KunrenInfoField = _interopRequireDefault(require("../common/components/KunrenInfoField"));
var _MedplanFieldDisp = _interopRequireDefault(require("./components/MedplanFieldDisp"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FieldSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});

/**
 * 訓練中期計画登録結果画面
 */
class KunrenMedplanEntryResult extends _react.default.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl,
      goMain,
      entries,
      kunrenInfo
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_RESULT_TITLE
      })
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 8
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register"
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 4
      },
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
      onClick: () => goMain(true),
      autoWidth: true,
      negative: true
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
    })))), /*#__PURE__*/_react.default.createElement(_KunrenInfoField.default, {
      data: kunrenInfo,
      hiddenFlg: true
    }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_MedplanFieldDisp.default, {
      entries: entries
    }))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      },
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
      onClick: () => goMain(true),
      autoWidth: true,
      negative: true
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
    }))))));
  }
}
const mapStateToProps = state => ({
  entries: state.bcmKunren.entries,
  kunrenInfo: state.bcmKunren.kunrenInfo
});
const mapDispatchToProps = dispatch => {
  return {
    goMain: doSearch => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.GO_MAIN](doSearch))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KunrenMedplanEntryResult)));